import React from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";

import {featureInterface} from "./featureInterface";
import SvgIcons from "../../Icons/SvgIcons";
import {getFeatureEditPermission} from "../featuresFunctions";
import {showNewFeatureOverlay} from "../../FeatureCreator/NewFeature/NewFeatureActions";
import FeaturesSetupFeatureActionsTopLinkButton from "./FeaturesSetupFeatureActionsTopLinkButton";
import {featuresSetupSetEditPopupFeatureId, setFeaturesSetupTogglePopupOpened} from "../featuresActions";


const FeaturesSetupFeatureActionsTop = (props) => {

  const {feature, showNewFeatureOverlay, groupName, canEdit, setFeaturesSetupTogglePopupOpened,
    featuresSetupSetEditPopupFeatureId} = props;

  const editFeatureClick = () => {
    if (!canEdit) {
      return false
    }
    featuresSetupSetEditPopupFeatureId(feature.featureDefinitionId);
    showNewFeatureOverlay(true, groupName, feature.featureDefinitionId)
  }

  const editTogglesClick = () => {
    if (!canEdit) {
      return false
    }
    setFeaturesSetupTogglePopupOpened(true, feature)
  }

  return (
    <div className="fs-feature__actions-cell">
      <div className="fs-feature__action">
        <button className={"ui-icon--rounded ui-icon-blue ui-icon-edit ui-icon-edit--blue"
          + (canEdit ? "" : " ui-icon-blue--disabled")}
                onClick={editFeatureClick}/>
      </div>
      <div className="fs-feature__action">
        <button className={"ui-icon--rounded ui-icon-blue" + (canEdit ? "" : " ui-icon-blue--disabled")}
                onClick={editTogglesClick}>
          {SvgIcons.toggle}
        </button>
      </div>
      <FeaturesSetupFeatureActionsTopLinkButton feature={feature}/>
    </div>
  )
};

FeaturesSetupFeatureActionsTop.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {groupName} = store.featuresSetupState;
  const {canEdit} = getFeatureEditPermission(store);

  return {
    canEdit,
    groupName,
  };
};

const mapDispatchToProps = {
  showNewFeatureOverlay,
  setFeaturesSetupTogglePopupOpened,
  featuresSetupSetEditPopupFeatureId,
};

export default connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureActionsTop)
